var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8282 17.229C13.7663 17.229 13.7047 17.2155 13.647 17.1875L8.99988 14.9419L4.3528 17.1875C4.21613 17.2534 4.05446 17.2403 3.93071 17.1525C3.80696 17.0648 3.74051 16.9169 3.75738 16.7663L4.35571 11.3996L0.874255 7.43046C0.776547 7.31921 0.745297 7.16442 0.792172 7.024C0.838838 6.88358 0.956755 6.77838 1.10155 6.74796L6.12217 5.69171L8.63238 0.991291C8.70467 0.855457 8.84613 0.770874 8.99988 0.770874C9.15363 0.770874 9.29509 0.855457 9.36738 0.991082L11.8778 5.69171L16.8984 6.74796C17.0432 6.77838 17.1609 6.88358 17.2078 7.024C17.2547 7.16442 17.2232 7.31921 17.1257 7.43046L13.644 11.3996L14.2424 16.7663C14.2593 16.9169 14.1928 17.0648 14.069 17.1525C13.9974 17.2032 13.913 17.229 13.8282 17.229Z",
    fill: "#F8D22D"
  })));
};
export default SvgStarFilled;